import Dexie, { type Table } from "dexie";
import { COLLECTIONS, type Collection, type LocalStore } from "./types";

class HexlingDb extends Dexie {
  notes!: Table<{ id: string }, string>;
  lists!: Table<{ id: string }, string>;
  listItems!: Table<{ id: string }, string>;
  bookmarks!: Table<{ id: string }, string>;
  meta!: Table<{ key: string; value: unknown }, string>;

  constructor(name: string) {
    super(name);
    this.version(1).stores({
      notes: "id",
      lists: "id",
      listItems: "id",
      bookmarks: "id",
      meta: "key",
    });
  }
}

/** IndexedDB storage for the web and PWA. */
export function createDexieStore(name = "hexling"): LocalStore {
  const db = new HexlingDb(name);
  return {
    all: async <T>(c: Collection) => (await db[c].toArray()) as T[],
    putMany: async (c, records) => {
      await db[c].bulkPut(records);
    },
    getMeta: async <T>(key: string) => (await db.meta.get(key))?.value as T | undefined,
    setMeta: async (key, value) => {
      await db.meta.put({ key, value });
    },
    clear: async () => {
      await db.transaction("rw", [...COLLECTIONS.map((c) => db[c]), db.meta], async () => {
        await Promise.all([...COLLECTIONS.map((c) => db[c].clear()), db.meta.clear()]);
      });
    },
  };
}
